import { z } from "zod";

enum LocationType {
  BANK = "Bank",
  WALLET = "Wallet",
  SEC_FIRM = "Securities Firm",
}

enum LocationTransferType {
  INITIAL_MARGIN = "Initial Margin",
  VARIATION_MARGIN = "Variation Margin",
  INTEREST = "Interest",
  FIXED_PAYMENT = "Fixed Payment",
  // TERMINATION_FEE = "Termination Fee",
  LOAN_PRINCIPAL = "Loan Principal",
  OTHER = "Other",
  SETTLEMENT = "Settlement",
}

const RegisterLocationSchema = z.object({
  user_id: z.string().uuid().optional(),
  name: z.string().min(1),
  location_type: z.nativeEnum(LocationType),
  owner: z.string().uuid().min(1),
  is_external: z.boolean(),
  secured_party: z.array(z.string()),
  account_control_agreement: z.boolean(),
  details: z.any(),
});

const LocationFundSchema = z.object({
  user_id: z.string().uuid().optional().or(z.literal("")),
  asset: z.string().min(1),
  amount: z.string().min(1),
  location_id: z.string().uuid().min(1),
  margin_group_id: z.string().uuid().min(1),
});

const LocationSendFundSchema = z.object({
  user_id: z.string().uuid().optional().or(z.literal("")),
  receiver_margin_group_id: z.string().uuid().min(1),
  sender_margin_group_id: z.string().uuid().min(1),
  asset: z.string().min(1),
  amount: z.string().min(1),
  transfer_type: z.nativeEnum(LocationTransferType),
  receiver_location_id: z.string().uuid().min(1),
  sender_location_id: z.string().uuid().min(1),
  reference_transaction_id: z.string().uuid().optional().or(z.literal("")),
  details: z.union([
    z.object({
      fed_reference_number: z.string().optional(),
      notes: z.string().optional(),
    }),
    z.object({
      notes: z.string().optional(),
    }),
  ]),
});

const LocationSchema = z.object({
  id: z.string().uuid().min(1),
  name: z.string().min(1),
  location_type: z.nativeEnum(LocationType),
  custodian: z.string().min(1),
  owner: z.string().uuid().min(1),
  secured_party: z.array(z.string()),
  account_control_agreement: z.boolean(),
  details: z.any(),
  balance: z.string().min(1),
});

type RegisterLocationType = z.infer<typeof RegisterLocationSchema>;
type LocationFundType = z.infer<typeof LocationFundSchema>;
type LocationSendFundType = z.infer<typeof LocationSendFundSchema>;
type LocationResourceType = z.infer<typeof LocationSchema>;

export type { RegisterLocationType, LocationFundType, LocationSendFundType, LocationResourceType };
export {
  LocationType,
  LocationTransferType,
  RegisterLocationSchema,
  LocationFundSchema,
  LocationSendFundSchema,
  LocationSchema,
};
